module.exports = __webpack_public_path__ + "static/media/downtime-log.cc590cbf.png";